/* ============================================================
   Mahal Liss - comportements de conversion
   1. Apparitions au scroll
   2. Barre de menu mobile (5 rubriques)
   3. Bandeau livraison
   4. Jauge panier : livraison offerte + paliers de remise
   5. Bouton d'achat collant sur mobile (fiche produit)
   6. Description de collection repliee (Lire la suite)
   7. Nettoyage des bandeaux vides laisses par des apps
   ============================================================ */

/* --- 1. Apparitions au scroll --- */
(function(){
  var els = document.querySelectorAll('.ml-reveal, .ml-reveal-left, .ml-reveal-right');
  if (!els.length) return;
  var io = new IntersectionObserver(function(entries){
    entries.forEach(function(e){
      if (e.isIntersecting) { e.target.classList.add('ml-visible'); io.unobserve(e.target); }
    });
  }, { threshold: 0.12 });
  els.forEach(function(el){ io.observe(el); });
})();

/* --- 2. Barre de menu mobile : 5 rubriques courtes --- */
(function(){
  var nav = document.querySelector('.ml-mobile-nav');
  if (!nav) return;
  var links = [
    { label: 'Lissages',     href: '/collections/nos-lissages-formats-professionnels' },
    { label: 'Mini kits',    href: '/collections/minis-kits-lissages-et-btx' },
    { label: 'Entretien',    href: '/collections/gamme-dentretien-lissage-sans-sulfates' },
    { label: 'Best-sellers', href: '/collections/nos-best-sellers' },
    { label: 'Pro',          href: '/collections/lots-revendeurs' }
  ];
  var path = window.location.pathname;
  nav.innerHTML = '';
  links.forEach(function(l){
    var a = document.createElement('a');
    a.href = l.href;
    a.textContent = l.label;
    if (path.indexOf(l.href) === 0) a.classList.add('active');
    nav.appendChild(a);
  });
})();

/* --- 3. Bandeau livraison --- */
(function(){
  var bar = document.querySelector('.ml-shipping-bar');
  if (!bar) return;
  bar.innerHTML = '✦ <strong>Livraison offerte</strong> dès 60 € · France, Belgique, Espagne · <em>-10 % dès 2 produits</em> ✦';
})();

/* --- Styles injectes --- */
(function(){
  if (document.getElementById('ml-conv-styles')) return;
  var css = ''
    + '.ml-cartgauge{display:block;margin:14px 0 18px;padding:14px 16px;border:1px solid rgba(107,30,44,.15);border-radius:10px;background:#FFFFFF;font-size:13px;line-height:1.5;color:#4A1220}'
    + '.ml-cartgauge__line{display:block;margin-bottom:10px}'
    + '.ml-cartgauge__line strong{font-weight:700}'
    + '.ml-cartgauge__track{display:block;width:100%;height:7px;border-radius:999px;background:rgba(107,30,44,.12);overflow:hidden;margin-bottom:11px}'
    + '.ml-cartgauge__fill{display:block;height:7px;min-width:7px;background:linear-gradient(to right,#6B1E2C,#C9A96E);border-radius:999px;transition:width .4s ease}'
    + '.ml-cartgauge__tier{display:block;font-size:12.5px;color:#6B1E2C;opacity:.95}'
    + '.ml-cartgauge__ok{color:#2F6B4F;font-weight:600}'
    + '.ml-stickyatc{position:fixed;left:0;right:0;bottom:0;z-index:9998;display:none;align-items:center;gap:12px;padding:10px 14px;background:#fff;border-top:1px solid rgba(107,30,44,.15);box-shadow:0 -6px 18px rgba(74,18,32,.10)}'
    + '.ml-stickyatc.is-on{display:flex}'
    + '.ml-stickyatc__info{flex:1;min-width:0}'
    + '.ml-stickyatc__name{display:block;font-size:12.5px;line-height:1.25;color:#1a1a1a;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}'
    + '.ml-stickyatc__price{display:block;font-size:14px;font-weight:700;color:#6B1E2C;margin-top:2px}'
    + '.ml-stickyatc__btn{flex:none;background:#6B1E2C;color:#fff;border:0;border-radius:4px;padding:13px 22px;font-size:14px;font-weight:600;letter-spacing:.4px;cursor:pointer}'
    + '.ml-stickyatc__btn:active{background:#4A1220}'
    + '@media (min-width:990px){.ml-stickyatc{display:none !important}}'
    + 'body.ml-pdp .ml-sticky-bar{display:none !important}';
  var s = document.createElement('style');
  s.id = 'ml-conv-styles';
  s.textContent = css;
  document.head.appendChild(s);
})();

/* --- 4. Jauge panier --- */
(function(){
  var SEUIL = 6000;
  var fmt = function(c){ return (c/100).toFixed(2).replace('.', ',') + ' €'; };

  function build(cart){
    var reste = SEUIL - cart.total_price;
    var pct = Math.min(100, Math.round((cart.total_price / SEUIL) * 100));
    var n = cart.item_count;
    var ligne, tier;
    if (reste > 0) {
      ligne = 'Plus que <strong>' + fmt(reste) + '</strong> pour la livraison offerte';
    } else {
      ligne = '<span class="ml-cartgauge__ok">✓ Livraison offerte débloquée</span>';
    }
    if (n <= 1) {
      tier = 'Ajoutez un 2ᵉ produit et bénéficiez de -10 %';
    } else if (n === 2) {
      tier = '<span class="ml-cartgauge__ok">✓ -10 % atteint</span> · un 3ᵉ produit pour -15 %';
    } else if (n < 5) {
      tier = '<span class="ml-cartgauge__ok">✓ -15 % atteint</span> · 5 produits pour -20 %';
    } else {
      tier = '<span class="ml-cartgauge__ok">✓ -20 %, le meilleur palier</span>';
    }
    return '<span class="ml-cartgauge__line">' + ligne + '</span>'
         + '<span class="ml-cartgauge__track"><span class="ml-cartgauge__fill" style="width:' + pct + '%"></span></span>'
         + '<span class="ml-cartgauge__tier">' + tier + '</span>';
  }

  function mountPoints(){
    var pts = [];
    var d = document.querySelector('cart-drawer form, .cart-drawer__form, #CartDrawer .drawer__inner');
    if (d) pts.push(d);
    var p = document.querySelector('#main-cart-footer, .cart__footer');
    if (p) pts.push(p);
    return pts;
  }

  function render(cart){
    if (!cart || typeof cart.total_price !== 'number') return;
    mountPoints().forEach(function(pt){
      var box = pt.querySelector(':scope > .ml-cartgauge');
      if (cart.item_count === 0) { if (box) box.remove(); return; }
      if (!box) { box = document.createElement('div'); box.className = 'ml-cartgauge'; pt.insertBefore(box, pt.firstChild); }
      box.innerHTML = build(cart);
    });
  }

  function refresh(){
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function(r){ return r.json(); }).then(render).catch(function(){});
  }

  function init(){
    refresh();
    ['cart:refresh','cart:update','cart-drawer:open'].forEach(function(ev){
      document.addEventListener(ev, function(){ setTimeout(refresh, 250); });
    });
    document.addEventListener('click', function(e){
      if (e.target.closest('[name="add"], .quick-add__submit, .quantity__button, cart-remove-button, .cart-item__quantity a')) {
        setTimeout(refresh, 700);
      }
    }, true);
    var drawer = document.querySelector('cart-drawer');
    if (drawer && window.MutationObserver) {
      new MutationObserver(function(){ setTimeout(refresh, 150); }).observe(drawer, { childList: true, subtree: true });
    }
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }
})();

/* --- 5. Bouton d'achat collant sur mobile --- */
(function(){
  function init(){
    if (window.location.pathname.indexOf('/products/') === -1) return;
    var realBtn = document.querySelector('.product-form__submit, button[name="add"]');
    if (!realBtn) return;
    document.body.classList.add('ml-pdp');
    var titleEl = document.querySelector('.product__title h1, .product__title, h1');
    var priceEl = document.querySelector('.price__sale .price-item--sale, .price__regular .price-item--regular, .price-item');
    var bar = document.createElement('div');
    bar.className = 'ml-stickyatc';
    bar.innerHTML = '<span class="ml-stickyatc__info"><span class="ml-stickyatc__name"></span><span class="ml-stickyatc__price"></span></span><button type="button" class="ml-stickyatc__btn">Ajouter au panier</button>';
    bar.querySelector('.ml-stickyatc__name').textContent = titleEl ? titleEl.textContent.trim() : '';
    bar.querySelector('.ml-stickyatc__price').textContent = priceEl ? priceEl.textContent.trim().replace(/\s+/g, ' ') : '';
    document.body.appendChild(bar);
    bar.querySelector('.ml-stickyatc__btn').addEventListener('click', function(){ realBtn.click(); });
    if (window.IntersectionObserver) {
      new IntersectionObserver(function(entries){
        entries.forEach(function(e){ bar.classList.toggle('is-on', !e.isIntersecting && e.boundingClientRect.top < 0); });
      }, { threshold: 0 }).observe(realBtn);
    }
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }
})();

/* --- 6. Description de collection repliee --- */
(function(){
  function init(){
    var desc = document.querySelector('.collection-hero__description, .collection-hero .rte');
    if (!desc || desc.dataset.mlClamped) return;
    desc.dataset.mlClamped = '1';
    desc.classList.add('ml-clamp');
    if (desc.scrollHeight <= desc.clientHeight + 4) { desc.classList.remove('ml-clamp'); return; }
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'ml-more';
    btn.textContent = 'Lire la suite';
    desc.insertAdjacentElement('afterend', btn);
    btn.addEventListener('click', function(){
      var open = desc.classList.toggle('ml-clamp');
      btn.textContent = open ? 'Lire la suite' : 'Réduire';
    });
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }
})();

/* --- 7. Nettoyage des bandeaux vides laisses par des apps --- */
(function(){
  function sweep(){
    var sel = '.shopify-section, .shopify-app-block, [id^="shopify-block"], .shopify-section-group-header-group > div';
    document.querySelectorAll(sel).forEach(function(el){
      if (el.dataset.mlSwept) return;
      if (el.querySelector('img, video, svg, iframe, canvas, input, button, a')) return;
      if (el.textContent.replace(/\s+/g, '') !== '') return;
      var h = el.offsetHeight;
      if (h > 0 && h < 90) {
        el.dataset.mlSwept = '1';
        el.style.display = 'none';
      }
    });
  }
  function init(){ sweep(); setTimeout(sweep, 900); setTimeout(sweep, 2500); }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }
})();
